import styles from "./Login.module.scss";
import { Form } from "antd";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import globeIcon from "../../assets/images/login/globe.svg";
import FormItemInput from "../../components/ui/FormItemInput/FormItemInput";
import FormItemInputPassword from "../../components/ui/FormItemInputPassword/FormItemInputPassword";
import CustomButton from "../../components/ui/CustomButton/CustomButton";
import { emailValidation } from "../../helper/auth";
import { AuthService } from "../../services/auth.service";
import useAppDispatch from "../../hooks/useAppDispatch";
import { login } from "../../store/userProfile/userProfileSlice";
import { useEffect } from "react";
import { openSuccessMessage } from "../../store/message/messageSlice";
import { getLanguageFromLocal } from "../../helper/language";
import GoogleSignInButton from "../../components/GoogleSignInButton/GoogleSignInButton";
import { handleError } from "../../helper/errorHandler";
import FacebookSignInButton from "../../components/FacebookSignInButton/FacebookSignInButton";
import AppleSignInButton from "../../components/AppleSignInButton/AppleSignInButton";

const Login = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (location.search) {
      const searchParams = new URLSearchParams(location.search);
      const message = searchParams.get("success-message");
      if (message) {
        dispatch(openSuccessMessage(t(message)));
        searchParams.delete("otp-token");
        navigate("/login");
      }
    }
  }, [location]);

  const sendVerifyEmail = async (email: string) => {
    try {
      const response = await AuthService.sendVerifyMail({ email, lang: getLanguageFromLocal() });
      if (response.status === 200) {
        navigate(
          `/success?title=${t("WelcomeToClubPass")}&description=${t("SuccessForRegisterText")}`
        );
      }
    } catch (e) {
      handleError(e, dispatch, t);
    }
  };

  const onFinish = async (values: { email: string; password: string }) => {
    const model = {
      email: values.email.trim(),
      password: values.password.trim(),
    };

    // if (!emailValidation(model.email)) {
    //     dispatch(openMessage({isOpen: true, type: "error", title: t("PleaseEnterYourEmailCorrectly")}))
    //     return;
    // }

    try {
      const response = await AuthService.login(model as { email: string; password: string });
      if (response?.status === 200) {
        const res = await AuthService.getCurrentUser();
        if (res && res.status === 200) {
          dispatch(login(res.data));
          navigate("/your-location");
        } else {
          handleError(new Error("SOMETHING_WENT_WRONG"), dispatch, t);
        }
      } else {
        handleError(new Error("SOMETHING_WENT_WRONG"), dispatch, t);
      }
    } catch (e: any) {
      if (e.response?.data?.reason === "USER_NOT_VERIFIED") {
        sendVerifyEmail(values.email);
      }
      handleError(e, dispatch, t);
    }
  };

  return (
    <div className="container">
      <div className={styles.container}>
        <div className={styles.box}>
          <div className={styles.boxTop}>
            <img src={globeIcon} alt={"globe"} />
            <h2
              dangerouslySetInnerHTML={{ __html: t("WelcomeToClubPass") }}
              className={styles.title}
            ></h2>
          </div>

          <Form
            className={styles.form}
            name="login"
            initialValues={{ remember: true }}
            onFinish={onFinish}
            autoComplete="off"
            layout={"vertical"}
          >
            <FormItemInput name={"email"} label={t("EmailAddress")} rules={{ required: true }} />
            <FormItemInputPassword
              name={"password"}
              label={t("Password")}
              rules={{ required: true }}
            />

            <div className={styles.forgot}>
              <Link to={"/forgot-password"}>{t("ForgotYourPassword")}</Link>
            </div>

            <div className={styles.btnWrapper}>
              <CustomButton text={t("SignIn")} type={"submit"} typeStyle={"fill"} />
            </div>

            <div className={styles.register}>
              {t("NotMemberYet")}
              <Link to={"/register"}> {t("JoinUsNow")}</Link>
            </div>

            <div className={styles.or}>{t("Or")}</div>
          </Form>

          <div className={styles.btnsWrapper}>
            <GoogleSignInButton />
            <FacebookSignInButton />
            <AppleSignInButton />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
